export default [
  {
    path: '/configuracoes',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ './Form.vue'),
    meta: { auth: true }
  }
]
